// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"c3b05f68","732":"0361648c","977":"87759628"}[chunkId] + ".chunk.js";
};